import React, { useState } from "react";
import { Button, Input, Modal, Card, Toggle } from "uni-elements";
import { AiOutlineClose, AiOutlineSearch } from "react-icons/ai"; // Import the close icon

function App() {
  const [name, setName] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false); // State to toggle modal
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false); // State for confirm modal
  const [toggleChecked, setToggleChecked] = useState(false); // State for toggle

  const handleConfirm = () => {
    alert("Confirmed!");
    setIsConfirmModalOpen(false);
  };

  return (
    <div className="flex flex-col items-center justify-center bg-[rgb(248,247,244)]">
      {/* <Button label="Click me" onClick={() => alert("Hello, world!")} /> */}
      <p className="text-4xl font-semibold  w-full text-center pt-14 pb-4 font-sans">
        UniElements 🦄
      </p>
      <div className="flex items-right justify-start flex-col space-y-8 p-12 w-1/2  mx-auto">
        <div className="flex flex-col items-left space-y-1">
          <p className="text-lg">Button</p>
          <div className="flex space-x-2 ">
            <Button label="Primary" variant="primary" />
            <Button label="Secondary" variant="secondary" />
            <Button label="Danger" variant="danger" />
            <Button label="Disabled" disabled />
            <Button label="Disabled" disabled icon={<AiOutlineClose />} />
          </div>
        </div>
        <div className="flex-col items-center space-y-2 items-left">
          <p className="text-lg">Input</p>
          <Input
            className="w-[300px]"
            placeholder="Enter your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <Input
            className="w-[300px]"
            placeholder="Search..."
            value={name}
            onChange={(e) => setName(e.target.value)}
            icon={<AiOutlineSearch />}
          />
        </div>
        <div className="flex-col space-y-2">
          <p className="text-lg">Modal</p>
          <Button
            label="Toggle Modal"
            onClick={() => setIsModalOpen(!isModalOpen)}
          />
          <Modal
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            title="Modal Title"
          >
            <p>This is a modal content</p>
          </Modal>
          <Button
            label="Toggle Confirm Modal"
            onClick={() => setIsConfirmModalOpen(true)}
          />
          <Modal
            isOpen={isConfirmModalOpen}
            onCancel={() => setIsConfirmModalOpen(false)}
            onConfirm={handleConfirm}
            title="Confirm Modal Title"
          >
            <p>Are you sure you want to proceed?</p>
          </Modal>
        </div>
        <div className="flex-col items-center space-y-1">
          <p className="text-lg">Toggle</p>
          <Toggle
            checked={toggleChecked}
            onChange={(e) => setToggleChecked(e.target.checked)}
          />
        </div>

        <div className="flex-col items-center space-y-1">
          <p className="text-lg">Card</p>
          <Card title="Card Title">
            <p>This is a card content</p>
          </Card>
          <Card>
            <p>This is a card content</p>
          </Card>
        </div>
      </div>
      <footer className="w-full text-center p-4 text-sm text-gray-600">
        daniel.longo@stanford.edu | DDL Labs 2024
      </footer>
    </div>
  );
}

export default App;
